<label
  class="core-ui-switch"
  [class.core-ui-switch--sm]="size === 'sm'"
  [class.core-ui-switch--md]="size === 'md'"
  [class.core-ui-switch--lg]="size === 'lg'"
  [class.is-checked]="checked"
  [class.is-disabled]="isDisabled"
  [class.is-readonly]="readOnly"
>
  <input
    class="core-ui-switch__input"
    type="checkbox"
    role="switch"
    [checked]="checked"
    [disabled]="isDisabled"
    [required]="required"
    [attr.name]="name"
    [value]="value"
    [attr.aria-label]="ariaLabel || label || 'Cambiar estado'"
    [attr.aria-readonly]="readOnly"
    (change)="onToggle($event)"
    (blur)="markAsTouched()"
  />

  <span class="core-ui-switch__control" aria-hidden="true">
    <span class="core-ui-switch__thumb">
      <core-ui-icon
        *ngIf="checked && showIcon"
        name="icon_check"
        [size]="iconSize"
      ></core-ui-icon>
    </span>
  </span>

  <span *ngIf="label" class="core-ui-switch__label">{{ label }}</span>
</label>
